import { useFormContext, useWatch } from "react-hook-form";
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { format } from "date-fns";
import { Switch } from "@/components/ui/form";
import { AvailabilitySlots } from "./availability-slots";
import { AvailabilityBadges } from "../availability-badges";

export const AvailabilityItem = ({ day }) => {
    const dayLong = format(day, "EEEE");
    const dayShort = format(day, "EEE");

    const { control, clearErrors } = useFormContext();
    const enabled = useWatch({
        control,
        name: `${dayShort}.enabled`,
    });

    const times = useWatch({
        control,
        name: `${dayShort}.Times`,
    });

    const handleCheckedChange = () => {
        clearErrors(`${dayShort}.Times`);
    };

    return (
        <Disclosure as="div" defaultOpen={false} className="group">
            <div className="relative flex min-w-0 flex-wrap pt-3 md:pt-0">
                <div className="shrink-0 cursor-default ps-3 md:py-3 [&_label]:pl-2 md:[&_label]:pl-3">
                    <Switch
                        name={`${dayShort}.enabled`}
                        label={dayLong}
                        onChange={handleCheckedChange}
                        labelPlacement="end"
                        size="sm"
                        className="gap-0 text-base font-medium"
                    />
                </div>
                <DisclosureButton className="group flex min-w-0 flex-1 cursor-pointer items-center justify-end px-3 md:py-3">
                    <div className="me-8 flex w-full min-w-0 flex-1 flex-wrap justify-end gap-2 overflow-hidden text-right text-sm/5 text-neutral-500 group-data-hover:text-neutral-600 md:me-4 md:me-9">
                        <AvailabilityBadges
                            enabled={enabled}
                            times={times}
                            day={dayShort}
                        />
                    </div>
                    <ChevronDownIcon className="absolute top-1/2 size-6 shrink-0 -translate-y-1/2 group-data-hover:text-darkgreen-400 group-data-open:rotate-180" />
                </DisclosureButton>
                {/* Mobile only */}
                <DisclosureButton className="flex w-[90%] flex-wrap gap-1 p-1 px-3 pb-2 md:hidden">
                    <AvailabilityBadges
                        enabled={enabled}
                        times={times}
                        day={dayShort}
                        mobile={true}
                    />
                </DisclosureButton>
            </div>
            <DisclosurePanel className="grid border-t border-gray-300 p-3">
                {enabled ? (
                    <AvailabilitySlots day={dayShort} />
                ) : (
                    <p className="text-sm">
                        Check the switch above to add time slots
                    </p>
                )}
            </DisclosurePanel>
        </Disclosure>
    );
};
